import { useStore } from '@/hooks/useStore';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useEffect, useState, useRef } from 'react';
import { Button } from '@/components/common/Button';
import { useTranslation } from 'react-i18next';
import { ITEMS_CONST, ROUTES } from '@/configs/constants';
import { toastify } from '@/utils/toastify';
import Header from '@/components/layout/Header';
import { flowResult } from 'mobx';
import bgItem from '../../assets/images/pngs/item-location.png';
import RadioButtonComponent from '@/components/common/RadioButton';
import warningImg from '@/assets/images/pngs/Warning.png';

export default observer(function ListItemsNearBy() {
    // store
    const {
        itemsStore: { getListNearBy, collectItem, reportItem, listNearBy = [] },
        modalStore: { hideModal, showModal },
        apiStore: { setLoading }
    } = useStore();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [listData, setListData] = useState([]);
    // const [isDownloading, setIsDownloadind] = useState(false);
    const listRef = useRef(null);
    const [visibleCount, setVisibleCount] = useState(10);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [reportItemData, setReportItemData] = useState(null);

    // const downloadFile = async (fileUrl) => {
    //     try {
    //         const response = await fetch(fileUrl);
    //         if (!response.ok) throw new Error('Tải file thất bại');

    //         const blob = await response.blob();
    //         const url = window.URL.createObjectURL(blob);
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.download = fileUrl.split('/').pop();
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         window.URL.revokeObjectURL(url);
    //     } catch (error) {
    //         toastify('error', t('messages.errorTryAgain'));
    //     }
    // };

    // const downloadFilesSequentially = async (fileUrls) => {
    //     for (const fileUrl of fileUrls) {
    //         await downloadFile(fileUrl);
    //         await new Promise(resolve => setTimeout(resolve, 2000)); // Delay giữa các lần tải
    //     }
    //     // setIsDownloadind(false);
    // };

    const handleDownload = async () => {
        if (!selectedItemId) return;
        // setIsDownloadind(true);
        // const listSelected = [];
        // [...listData].forEach((element) => {
        //     element.isSelected === true && listSelected.push(element.file.path);
        // });
        // downloadFilesSequentially(listSelected);

        const selectedItem = listData.find(item => item.id === selectedItemId);
        if (!selectedItem) {
            toastify('error', t('messages.errorTryAgain'));
            // setIsDownloadind(false);
            return;
        }

        // Gọi API collect item
        const res = await flowResult(collectItem(selectedItemId));
        if (res) {
            toastify('success', t('text.getted'));
            // ✅ Gọi lại danh sách
            const newList = await flowResult(getListNearBy());

            // ✅ Nếu danh sách rỗng thì quay về home
            if (!newList || newList.length === 0) {
                navigate(ROUTES.home.href);
                return;
            }
            setSelectedItemId(null); // reset lựa chọn
            // showModal({
            //     id: 'collect-success',
            //     showCloseIcon: false,
            //     cancelButton: false,
            //     saveButton: false,
            //     closeWhenOutside: true,
            //     onCancel: () => {
            //         navigate(ROUTES.listNearBy.href);
            //     },
            //     content: (
            //         <div className='w-full flex flex-col justify-center items-center'>
            //             <img src={doneImg} alt={doneImg} className='w-[263px] h-[244px]' />
            //             <p className='text-[15px] font-semibold text-gray mt-6'>{t('text.getted')}</p>
            //         </div>
            //     )
            // });
        }

        // setIsDownloadind(false);

        // if (selectedItem) {
        //     downloadFilesSequentially([selectedItem.file.path]);
        // }
    };
    const backToHome = () => {
        navigate(ROUTES.home.href);
    };

    useEffect(() => {
        getList();
        hideModal('geting-near-items');
    }, []);

    const getList = async () => {
        const res = await flowResult(getListNearBy());
        if (res && res.length > 0 && isFirstLoad) {
            toastify('info', t('text.listItemsNearBy', { length: res.length }));
            setIsFirstLoad(false); // ✅ Đảm bảo chỉ toast 1 lần
        }
    };

    useEffect(() => {
        if (listNearBy) {
            setListData(listNearBy.map(e => ({ ...e, isSelected: false })));
        }
    }, [listNearBy]);

    const handleScroll = () => {
        if (!listRef.current) return;
        const { scrollTop, scrollHeight, clientHeight } = listRef.current;
        if (scrollTop + clientHeight >= scrollHeight - 10) {
            setLoading(true);
            setTimeout(() => {
                setVisibleCount(prev => prev + 10);
                setLoading(false);
            }, 500);
        }
    };

    const handleReport = async (item) => {
        setReportItemData(item); // Lưu item đang report
        showModal({
            id: 'report-item',
            title: t('text.confirmReport'),
            saveButton: false,
            cancelButton: false,
            showBorder: true,
            titleClassName: 'absolute top-4 left-4',
            content: (
                <div className='w-full text-start flex flex-col justify-center items-center'>
                    <p className='text-[13px] font-medium text-textDes'>
                        <span className=''>{t('text.confirmReportDes', { itemName: item?.item })}</span>
                        <span className='text-txtReport'>{t('text.report')}</span>
                        <span>{t('text.confirmReportDes2')}</span>
                    </p>
                    <div className='flex flex-row text-center mt-6 w-full justify-center space-x-[10px]'>
                        <Button
                            variant='white'
                            onClick={() => {
                                hideModal('report-item');
                            }}
                            className='w-full'
                        >
                            {t('text.cancle')}
                        </Button>
                        <Button
                            variant='main'
                            onClick={handleConfirmReportItem}
                            className='w-full'
                        >
                            {t('text.ok')}
                        </Button>
                    </div>
                </div>
            )
        });
    };

    const handleConfirmReportItem = async () => {
        if (!reportItemData?.id) return;
        const res = await flowResult(reportItem(reportItemData.id));
        if (res) {
            hideModal('report-item');
            toastify('success', t('text.reportSuccess'));
            // setTimeout(() => {
            //     navigate(ROUTES.listNearBy.href);
            // }, 240);
            const newList = await flowResult(getListNearBy());

            // ✅ Nếu danh sách rỗng thì quay về home
            if (!newList || newList.length === 0) {
                navigate(ROUTES.home.href);
                return;
            }
        }
    };

    return (
        <div className='w-screen h-screen flex flex-col pt-[72px]'>
            <Header className='h-[72px]' title={t('text.listItemsNearBy', { length: listNearBy.length })} goBackFunction={backToHome} />
            <div
                onScroll={handleScroll}
                className='overflow-y-scroll mb-3 space-y-3 w-full h-[calc(100vh-72px-72px-40px-16px)]'
                ref={listRef}
            >
                {listData.slice(0, visibleCount).map(e => (
                    <div
                        key={e.id}
                        // onClick={() => {
                        //     navigate(ROUTES.detailItemCollected.href, { state: { itemId: e.id, isGeting: true } });
                        // }}
                        className='relative'
                    >
                        <div className={`flex items-center bg-white shadow-md w-full h-[124px] rounded-1 ${e.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && 'filter grayscale brightness-100'}`}>
                            <img src={bgItem} alt={bgItem} className='w-full h-full rounded-[4px]' />
                            <div className='w-[100px] h-[100px] absolute top-[12px] left-[12px] rounded-[4px]'>
                                <img src={e.file?.path} alt={e.file?.path} className='w-full h-full object-cover rounded-[4px]' />
                                {e?.itemType === ITEMS_CONST.ITEM_TYPE.COUPON && (
                                    <div className='absolute top-0 right-0 bg-gradient-to-r from-[#EA4335] to-[#F47843] text-white text-xs px-[12px] py-[2px] rounded-bl-sm rounded-tr-sm'>
                                        {t('text.coupon')}
                                    </div>
                                )}
                            </div>
                            <div className='absolute left-[124px] right-3 w-[calc(100vw-160px)]'>
                                <p className={`font-bold text-[15px] truncate ${e.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && 'text-textInactive'}`}>
                                    {e.item}
                                </p>
                                <p className={`text-gray text-[13px] line-clamp-2 break-words ${e.activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED && 'text-textInactive'}`}>{e.description}</p>

                                <button onClick={() => handleReport(e)} className='bg-bgReport text-white text-[13px] font-medium flex items-center space-x-[2px] px-2 py-1 rounded'>
                                    <img src={warningImg} alt={warningImg} className='w-3 h-3' />
                                    <p>{t('text.report')}</p>
                                </button>
                            </div>
                        </div>
                        <div
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                            className='w-10 h-10 absolute top-[14px] right-[14px] flex justify-end items-start'
                        >
                            {/* <CheckboxComponent
                                checked={e.isSelected}
                                onCheckedChange={value => setListData(prev => prev.map(it => it.id === e.id ? { ...it, isSelected: value } : { ...it }))}
                            /> */}
                            <RadioButtonComponent
                                items={[{ label: '', value: String(e.id) }]}
                                selectedValue={String(selectedItemId)}
                                onSelect={value => setSelectedItemId(Number(value))}
                                className='absolute top-[14px] right-[14px]'
                            />
                        </div>
                    </div>
                ))}
            </div>
            {listData && listData.length > 0 && (
                <div className='h-[72px] w-full bg-bgMain px-4 pb-4'>
                    <Button
                        variant='main'
                        // disabled={listData.filter(e => e.isSelected === true).length <= 0 || isDownloading}
                        disabled={!selectedItemId}
                        className='w-full h-[48px] rounded-[10px] space-x-[10px]'
                        onClick={handleDownload}
                    >
                        {/* <img src={downloadImng} alt={downloadImng} className='w-6 h-6' /> */}
                        <p>{t('text.btn_get_item')}</p>
                    </Button>
                </div>
            )}

        </div>

    );
});
